// Translate frontend pagination to backend pagination
// Frontend: page (1-indexed), count
// Backend: start (0-indexed), count
export const getBatchResponseStart = (page: number, size: number): number => {
  return (page - 1) * size;
};

export const getPagination = (
  totalItems: number,
  currentPage: number,
  pageSize: number,
  maxPageItems: 3 | 5 | 7 = 3,
): {
  totalPages: number;
  pages: number[];
} => {
  const totalPages = Math.ceil(totalItems / pageSize);

  let startPage: number;
  let endPage: number;

  if (totalPages <= maxPageItems) {
    startPage = 1;
    endPage = totalPages;
  } else {
    const half = Math.floor(maxPageItems / 2);

    if (currentPage <= half) {
      startPage = 1;
      endPage = maxPageItems;
    } else if (currentPage >= totalPages - half) {
      startPage = totalPages - (maxPageItems - 1);
      endPage = totalPages;
    } else {
      startPage = currentPage - half;
      endPage = currentPage + half;
    }
  }

  const pages = [...Array(endPage + 1 - startPage).keys()].map(
    (i) => startPage + i,
  );

  return {
    totalPages,
    pages,
  };
};
